import httpRequest from "../../../infrastructure/httphelper";
import sharedGlobals from "../../../sharedglobals";

class DashboardService{
    constructor() { }

    getUserDashboard() {
        let url =
          sharedGlobals.appUrls.reportManagerApiUrl + "api/Dashboard/GetUserDashboard";
        return httpRequest({
          url: url,
          method: "POST",
        });
      }
      getDashboardData(input) {
        let url =
          sharedGlobals.appUrls.reportManagerApiUrl + "api/Dashboard/GetDashboardData";
          return httpRequest({
            url: url,
            method: "POST",
            data: input
          });
    }
    getUserBranch() {
      let url =
        sharedGlobals.appUrls.reportManagerApiUrl + "api/Dashboard/GetUserBranch";
        return httpRequest({
          url: url,
          method: "POST",
    });
  }
    getAgentsList(input) {
      let url =
        sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetAgentsForSSODashboard";
        return httpRequest({
          url: url,
          method: "POST",
          params: input
    });
  }
  getSalesChannel() {
      let url =
        sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetSalesChannel";
        return httpRequest({
          url: url,
          method: "POST",
    });
  }
  CheckIfAgentOrBroker() {
    let url =
    sharedGlobals.appUrls.insSharedApiUrl + 'api/InsShared/CheckIfAgentOrBroker';
      return httpRequest({
        url: url,
        method: "GET",
  });
}
}
let instance = new DashboardService();
export default instance;